import {
  RedWrapper,
  BadgeText,
  BlueWrapper,
  YellowWrapper,
  PurpleWrapper
} from './Badges.styles';
import OnHoldTooltip from './OnHoldTooltip';

type OwnProps = Omit<React.HTMLProps<HTMLDivElement>, 'ref'>;

export const LockedBadge = (props: OwnProps) => (
  <RedWrapper {...props}>
    <BadgeText>Purchase in Progress</BadgeText>
  </RedWrapper>
);

export const PreOrderBadge = (props: OwnProps) => (
  <BlueWrapper {...props}>
    <BadgeText>Pre-Order Now</BadgeText>
  </BlueWrapper>
);

export const OnHoldBadge = ({
  showTooltip = true,
  ...rest
}: OwnProps & { showTooltip?: boolean }) => (
  <YellowWrapper {...rest}>
    {showTooltip ? <OnHoldTooltip /> : <BadgeText>On Hold</BadgeText>}
  </YellowWrapper>
);

export const RecentlyAddedBadge = (props: OwnProps) => (
  <PurpleWrapper {...props}>
    <BadgeText>Recently Added</BadgeText>
  </PurpleWrapper>
);
